import { render, staticRenderFns } from "./EditManager.vue?vue&type=template&id=488fa3d0"
import script from "./EditManager.vue?vue&type=script&lang=js"
export * from "./EditManager.vue?vue&type=script&lang=js"
import style0 from "./EditManager.vue?vue&type=style&index=0&id=488fa3d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports